import { Component, Input, OnInit } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerMissionFile',
  templateUrl: './LetterRequestCustomerMissionFile.component.html',
  styleUrls: ['./LetterRequestCustomerMissionFile.component.css']
})
export class LetterRequestCustomerMissionFileComponent implements OnInit {

  @Input() inner_Schedule_id: number = 0
  Filter_Letter: String = ""
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.ReadData_Schedules()
  }


  DataList_Schedules:Array<General_Interface>=[]
  ReadData_Schedules(){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetFilePeyvastActivity(this.inner_Schedule_id).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  AddFilePeyvastActivity(item:General_Interface){
    this.Procssing=true

    this.LetterRequestCustomer_Service.AddFilePeyvastActivity(item.id,this.inner_Schedule_id).subscribe(
      data=>{
        item.del=true
        item.reserve_id=data['id']
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  RemoveFilePeyvastActivity(item:General_Interface){
    this.Procssing=true

    this.LetterRequestCustomer_Service.RemoveFilePeyvastActivity(item.reserve_id).subscribe(
      data=>{
        item.del=false
        item.reserve_id=0
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
